import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { Button } from '@material-ui/core';
import BuildOutlined from '@material-ui/icons/BuildOutlined';
import CloudOffOutlined from '@material-ui/icons/CloudOffOutlined';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import RefreshRounded from '@material-ui/icons/RefreshRounded';
import PhoneOutlined from '@material-ui/icons/PhoneOutlined';
import logo from '../Sidebar/logo.png';
import './InstanceLoading.css';

const ICONS = {
    maintenance: BuildOutlined,
    network: CloudOffOutlined,
    unknown: ErrorOutline,
};

/**
 * Pantalla de "sistema no disponible": mantenimiento sin ingreso nuevo, sin red o error
 * inesperado al cargar el club. Habla en simple y ofrece reintentar o contactar al gimnasio.
 * El detalle técnico queda plegado para que soporte pueda pedirlo.
 */
const InstanceError = ({ t, error }) => {
    const kind = ICONS[error.kind] ? error.kind : 'unknown';
    const Icon = ICONS[kind];
    const club = error.clubName || t('instance_error_club_fallback');
    const phoneHref = error.clubPhone ? `tel:${error.clubPhone.replace(/[^\d+]/g, '')}` : null;

    const retry = () => {
        if (window.caches) {
            // La caché del service worker se limpia con caches.delete()
            window.caches.keys().then((names) => {
                names.forEach((name) => window.caches.delete(name));
            });
        }
        window.location.reload(true);
    };

    return (
        <div className="canvas instanceError">
            <section className="instanceErrorCard" role="alert" aria-labelledby="instanceErrorTitle">
                <img src={logo} alt="PowerGym" className="instanceErrorBrand" />
                <span className={`instanceErrorIcon ${kind}`} aria-hidden="true">
                    <Icon />
                </span>
                <h1 id="instanceErrorTitle" className="instanceErrorTitle">
                    {t(`instance_error_title_${kind}`)}
                </h1>
                <p className="instanceErrorLead">
                    {t(`instance_error_body_${kind}`, { club })}
                </p>
                <div className="instanceErrorActions">
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="large"
                        className="instanceErrorButton"
                        onClick={retry}
                    >
                        <RefreshRounded className="instanceErrorButtonIcon" />
                        {t('Retry')}
                    </Button>
                    {phoneHref && (
                        <Button
                            fullWidth
                            size="large"
                            component="a"
                            href={phoneHref}
                            className="instanceErrorButton instanceErrorSecondary"
                        >
                            <PhoneOutlined className="instanceErrorButtonIcon" />
                            {t('instance_error_call', { club })}
                        </Button>
                    )}
                </div>
                {error.devError ? (
                    <details className="instanceErrorDetails">
                        <summary>{t('instance_error_details')}</summary>
                        <pre>{error.devError}</pre>
                    </details>
                ) : null}
            </section>
        </div>
    );
};

InstanceError.propTypes = {
    t: PropTypes.func.isRequired,
    error: PropTypes.shape({
        kind: PropTypes.string,
        humanError: PropTypes.string,
        devError: PropTypes.string,
        clubName: PropTypes.string,
        clubPhone: PropTypes.string,
    }).isRequired,
};

export default withNamespaces()(InstanceError);
